import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
// Constants - Functions
import { pathHomePage } from "../../../../../config/constants";
import { activityIds, islandId, capsuleIds } from "../../../functions";
// Components
import { MainContainer, BackLink, ArrowImg, LinkText, PreviousAndNextDiv, NavigationButton, SeparatorDiv } from "./styles";
// Assets
import ArrowBackImg from "../../../../../assets/icons/ico_arrow_back.svg";
import ArrowLeftImg from "../../../../../assets/icons/ico_arrow_left_bold.svg";
import ArrowRightImg from "../../../../../assets/icons/ico_arrow_right_bold.svg";

const ActivityNavigation = () => {
  const icuProtocolIds = [...activityIds, ...islandId, ...capsuleIds];
  const { clinicianToken, patientId, protocolId } = useParams();
  const [t] = useTranslation("global");

  const updateActivityLink = (newProtocolId) => {
    window.location.href = `${pathHomePage}/reports/icu/${clinicianToken}/${patientId}/${newProtocolId}`;
  };

  const redirectPreviousSession = () => {
    const previousProtocolIdIndex = icuProtocolIds.indexOf(Number(protocolId)) - 1;
    const previousProtocolId = icuProtocolIds.at(previousProtocolIdIndex);
    updateActivityLink(previousProtocolId);
  };

  const redirectNextSession = () => {
    const nextProtocolIdIndex = icuProtocolIds.indexOf(Number(protocolId)) + 1;
    let nextProtocolId;
    if (nextProtocolIdIndex === icuProtocolIds.length) {
      nextProtocolId = icuProtocolIds.shift();
    } else {
      nextProtocolId = icuProtocolIds.at(nextProtocolIdIndex);
    }
    updateActivityLink(nextProtocolId);
  };

  const renderBackLink = () => {
    return (
      <BackLink to={`${pathHomePage}/activities/icu/${clinicianToken}/${patientId}`}>
        <ArrowImg src={ArrowBackImg} alt="ico-arrow-back" margin="0 10px 0 0" margin960="0 5px 0 0" />
        <LinkText>{t("rgsicu_activitiesList")}</LinkText>
      </BackLink>
    );
  };

  return (
    <MainContainer>
      {renderBackLink()}
      <PreviousAndNextDiv>
        <NavigationButton onClick={redirectPreviousSession}>
          <ArrowImg src={ArrowLeftImg} alt="ico-arrow-left" margin="0 10px 0 0" margin960="0 5px 0 0" />
          <LinkText>{t("previous")}</LinkText>
        </NavigationButton>
        <SeparatorDiv />
        <NavigationButton onClick={redirectNextSession}>
          <LinkText>{t("next")}</LinkText>
          <ArrowImg src={ArrowRightImg} alt="ico-arrow-right" margin="0 0 0 10px" margin960="0 0 0 5px" />
        </NavigationButton>
      </PreviousAndNextDiv>
    </MainContainer>
  );
};

export default ActivityNavigation;
